export function formatAmount(amount: number | null | undefined) : string {
  return amount != null ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount/100) : '';
}